// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__pvHqf","hand":"Home_hand__Q+EsB","wave":"Home_wave__wwfIN"};